import React from "react";
import { getUser, logout } from "../reducers/user";
import { generateUrl } from "../router";
import { AROMATHERAPY, AI_ASSISTANT } from "../constants";
import { hasFeature } from "../utils";
//import {history} from "../history";

export const LOGIN_ROUTE = "login";
export const REGISTER_ROUTE = "register";
export const RESET_PASSWORD_ROUTE = "forgot-password";
export const SET_PASSWORD_ROUTE = "set-password";
export const TERMS_ROUTE = "terms";
export const PRIVACY_ROUTE = "privacy";
export const DISCLAIMER_ROUTE = "disclaimer";
export const USER_ROUTE = "user";
export const HOME_ROUTE = "home";
export const ABOUT_ROUTE = "about";
export const HELP_ROUTE = "help";
export const RESOURCES_ROUTE = "resources";
export const LOGOUT_ROUTE = "logout";
export const AI_ROUTE = "ai";
export const CHATBOT_ROUTE = "chatbot";
export const CHATFILES_ROUTE = "chatfiles";
export const GUIDES_ROUTE = "guides";
export const ART_STYLES_ROUTE = "artstyles";

export const PROMPTTOOL_ROUTE = "prompttool";
export const PROMPTSET_ROUTE = "promptset";
export const PROMPT_ROUTE = "prompt";

export const COURSE_PROMPTS_ROUTE = "courseprompts";
export const COURSE_PROMPT_SET_ROUTE = "courseset";
export const COURSE_PROMPT_ROUTE = "courseprompt";
export const COURSE_CATEGORY_ROUTE = "coursecategory";

export const CATEGORY_ROUTE = "category";
export const CONTENT_CREATOR = "contentcreator";
export const AI_CONTENT_CREATOR = "aicontentcreator";
export const AI_IMAGES = "aimages";

// import { createBrowserHistory } from 'history';
// const history = createBrowserHistory();
import history from "../history";

const authRoutes = {
  path: "",
  children: [
    {
      path: "/",
      name: HOME_ROUTE,
      async action({ store }) {
        // Redirect root path to chatbot
        return { redirect: "/chatbot" };
      },
    },
    {
      path: "/about",
      name: ABOUT_ROUTE,
      load: () => import(/* webpackChunkName: 'chatbot' */ "./about"),
    },
    {
      path: "/replicate-image",
      load: () => import(/* webpackChunkName: 'replicate-image' */ "./replicate-image"),
    },
    {
      path: "/help",
      name: HELP_ROUTE,
      load: () => import(/* webpackChunkName: 'chatbot' */ "./help"),
    },
    {
      path: "/resources",
      name: RESOURCES_ROUTE,
      load: () => import(/* webpackChunkName: 'resources' */ "./resources"),
    },
    {
      path: "/account",
      name: USER_ROUTE,
      load: () => import(/* webpackChunkName: 'user' */ "./user"),
    },
    {
      path: "/ai",
      name: AI_ROUTE,
      load: () => import(/* webpackChunkName: 'user' */ "./ai"),
    },
    {
      path: "/chatbot",
      name: CHATBOT_ROUTE,
      load: () => import(/* webpackChunkName: 'chatbot' */ "./chatbot"),
    },
    {
      path: "/prompttool",
      name: PROMPTTOOL_ROUTE,
      load: () => import(/* webpackChunkName: 'prompttool' */ "./prompttool"),
    },

    {
      path: "/courseprompts",
      name: COURSE_PROMPTS_ROUTE,
      load: () => import(/* webpackChunkName: 'courseprompts' */ "./courseprompts"),
    },
    {
      path: "/courseprompts/category/:id", // Add this route
      name: COURSE_CATEGORY_ROUTE,
      load: () => import(/* webpackChunkName: 'courseprompts' */ "./courseprompts"),
    },
    {
      path: "/courseprompts/promptset/:id", // Add this route
      name: COURSE_PROMPT_SET_ROUTE,
      load: () => import(/* webpackChunkName: 'courseprompts' */ "./courseprompts"),
    },
    {
      path: "/courseprompts/prompt/:id",
      name: COURSE_PROMPT_ROUTE,
      load: () => import(/* webpackChunkName: 'courseprompts' */ "./courseprompts"),
    },

    {
      path: "/prompttool/promptset/:id",
      name: PROMPTSET_ROUTE,
      load: () => import(/* webpackChunkName: 'prompttool' */ "./prompttool"),
    },
    {
      path: "/prompttool/prompt/:id",
      name: PROMPT_ROUTE,
      load: () => import(/* webpackChunkName: 'prompttool' */ "./prompttool"),
    },
    {
      path: "/prompttool/category/:id",
      name: "CATEGORY_ROUTE",
      load: () => import(/* webpackChunkName: 'prompttool' */ "./prompttool"),
    },
    {
      path: "/chatfiles",
      name: CHATFILES_ROUTE,
      load: () => import(/* webpackChunkName: 'chatbot' */ "./chatfiles"),
    },
    {
      path: "/guides",
      name: GUIDES_ROUTE,
      load: () => import(/* webpackChunkName: 'chatbot' */ "./guides"),
    },
    {
      path: "/artstyles",
      name: ART_STYLES_ROUTE,
      load: () => import(/* webpackChunkName: 'chatbot' */ "./artstyles"),
    },
    {
      path: "/logout",
      name: LOGOUT_ROUTE,
      async action({ store, query }) {
        await store.dispatch(logout());
        return { redirect: query.next || generateUrl(CHATBOT_ROUTE) };
      },
    },
  ],
  async action({ store, next, pathname }) {
    const { loggedIn } = store.getState().user;
    if (!loggedIn) {
      return { redirect: `/login?next=${pathname}` };
    }
    return await next();
  },
};

// The top-level (parent) route
const routes = {
  path: "",

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: "/login",
      name: LOGIN_ROUTE,
      load: () => import(/* webpackChunkName: 'login' */ "./login"),
    },
    {
      path: "/aicontentcreator",
      name: AI_CONTENT_CREATOR,
      load: () => import(/* webpackChunkName: 'contentcreator' */ "./aicontentcreator"),
    },
    // {
    //   path: "/contentcreator",
    //   name: CONTENT_CREATOR,
    //   load: () => import(/* webpackChunkName: 'contentcreator' */ "./contentcreator"),
    // },
    {
      path: "/register",
      name: REGISTER_ROUTE,
      load: () => import(/* webpackChunkName: 'register' */ "./register"),
    },
    {
      path: "/reset-password",
      name: RESET_PASSWORD_ROUTE,
      load: () => import(/* webpackChunkName: 'resetPassword' */ "./resetPassword"),
    },
    {
      path: "/set-password",
      name: SET_PASSWORD_ROUTE,
      load: () => import(/* webpackChunkName: 'setPassword' */ "./setPassword"),
    },
    {
      path: "/terms",
      name: TERMS_ROUTE,
      load: () => import(/* webpackChunkName: 'terms' */ "./terms"),
    },
    {
      path: "/privacy",
      name: PRIVACY_ROUTE,
      load: () => import(/* webpackChunkName: 'privacy' */ "./privacy"),
    },
    authRoutes,
    // Wildcard routes, e.g. { path: '*', ... } (must go last)
    {
      path: "(.*)",
      load: () => import(/* webpackChunkName: 'notFound' */ "./notFound"),
    },
  ],

  async action({ next, store }) {
    await store.dispatch(getUser());
    // Execute each child route until one of them return the result
    const route = await next();

    // force a complete reset of token and data
    // every time the login route is accessed
    if (route.chunks && route.chunks[0] === "login") {
      await store.dispatch(logout());
    }
    /* const tokenobj = getToken()
     * if (tokenobj) {
     *     console.log("token = ", tokenobj.cookies);
     *     const history = await process.env.BROWSER && createBrowserHistory();
     *
     *     console.log(" history = ", history);
     *     if (history.push) {
     *         history.push("/")
     *     }
     * } else {
     *     await store.dispatch(logout());
     * } */

    // Provide default values for title, description etc.
    route.title = `${route.title || "Blend Precisely"}`;
    route.description = route.description || "A software business toolkit for Aromatherapists, Herbalists & Formulators.";

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: "/error",
    action: require("./error").default,
  });
}

export default routes;
